module.exports = __webpack_public_path__ + "static/media/Inter-LightItalic.5c1fed57.woff";